import { render, staticRenderFns } from "./AccountMenu.vue?vue&type=template&id=2f1d9f8b&scoped=true"
import script from "./AccountMenu.vue?vue&type=script&lang=js"
export * from "./AccountMenu.vue?vue&type=script&lang=js"
import style0 from "./AccountMenu.vue?vue&type=style&index=0&id=2f1d9f8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1d9f8b",
  null
  
)

export default component.exports